import {baseQuery} from "./baseQuery.ts";
import {createApi} from "@reduxjs/toolkit/query/react";

export const api = createApi({
    reducerPath: 'api',
    baseQuery,
    tagTypes: ['Queue', 'Numbers', 'Contact', 'User', 'Group','Groups', 'AdminGroups', 'Profile', 'MsisdnSettingsInfo', 'MsisdnSettings', 'MsisdnCallRules', 'MsisdnWorkingHours', 'Integration', 'Settings', 'Users', 'PhoneNumbers', 'Call', 'CallTranscript', 'CallSummary', 'Notifications', 'Webhooks', 'WebhookDeliveries', 'SecretKey', 'CalendarSettings', 'Statuses', 'ApiKeys', 'PhoneNumbersDnd','DndMissedCalls', 'EnsAlerts', 'EnsAlert', 'EnsStats', 'EnsConfig', 'EnsContacts', 'EnsContact', 'EnsMyAlerts', 'EnsPresets', 'EnsTemplates', 'ChatNotificationMutes', 'Calls'],
    endpoints: () => ({}),
});
export default api;
